import { Body, Box, Heading } from '@hover/blueprint';
import React, { useState } from 'react';
import { StyleProps } from '@chakra-ui/react';
import IntersectBox from '../../common/intersect-box';
import { ABOUT_SECTION_VALUES } from '../../../constants';

const wrapperStyles: StyleProps = {
  mt: 'calc(328px - 50vh)',
  display: { base: 'none', desktop: 'flex' },
  position: 'relative',
  w: '100%',
};

const imageStyles: StyleProps = {
  pt: 1000,
  flex: 1,
  position: 'sticky',
  top: 0,
  height: '100vh',
  flexDir: 'row',
  alignItems: 'center',
  justifyContent: 'center',
};

const headingWrapperStyles: StyleProps = {
  mt: 500,
  height: '100vh',
  flexDir: 'column',
  alignItems: 'flex-start',
  justifyContent: 'center',
  pl: 1000,
};

const headingStyles: StyleProps = {
  mb: 400,
  fontWeight: 'headingLight',
  marginBottom: 200,
};

const Desktop: React.FC = () => {
  const [sectionOneImageIntersect, setSectionOneIntersect] =
    useState<number>(0);
  const [sectionTwoImageIntersect, setSectionTwoIntersect] =
    useState<number>(0);
  const [sectionThreeImageIntersect, setSectionThreeIntersect] =
    useState<number>(0);

  return (
    <Box {...wrapperStyles}>
      <Box {...imageStyles}>
        {ABOUT_SECTION_VALUES.map(section => {
          let dim: number | string = 0;
          let opacity = 0;
          if (section.id === 0) {
            dim = sectionOneImageIntersect >= 0.3 ? 'auto' : 0;
            opacity = sectionOneImageIntersect;
          }
          if (section.id === 1) {
            dim =
              sectionTwoImageIntersect >= 0.3 && sectionOneImageIntersect < 0.3
                ? 'auto'
                : 0;
            opacity = sectionTwoImageIntersect;
          }
          if (section.id === 2) {
            dim =
              sectionThreeImageIntersect >= 0.3 &&
              sectionTwoImageIntersect < 0.3
                ? 'auto'
                : 0;
            opacity = sectionThreeImageIntersect;
          }
          return (
            <React.Fragment key={section.id}>
              <Box opacity={opacity} maxW="380px" w={dim} h={dim}>
                {section.image}
              </Box>
            </React.Fragment>
          );
        })}
      </Box>
      <Box flex={1} height="300vh" flexDir="column">
        {ABOUT_SECTION_VALUES.map(section => (
          <React.Fragment key={section.id}>
            <IntersectBox
              setSectionIntersect={entry => {
                if (section.id === 0) {
                  setSectionOneIntersect(entry);
                }
                if (section.id === 1) {
                  setSectionTwoIntersect(entry);
                }
                if (section.id === 2) {
                  setSectionThreeIntersect(entry);
                }
              }}
            >
              <Box {...headingWrapperStyles}>
                <Heading {...headingStyles} size={700} as="h3">
                  {section.header}
                </Heading>
                <Body size={500} mb={500} maxW="90%">
                  {section.body}
                </Body>
                <Body mb={500} size={500} isBold maxW="70%">
                  {section.sub}
                </Body>
              </Box>
            </IntersectBox>
          </React.Fragment>
        ))}
      </Box>
    </Box>
  );
};

export default Desktop;
